import { createStyles } from '@material-ui/core';

const styles = createStyles({
  container: {
    display: 'grid',
    gridAutoFlow: 'column',
    alignItems: 'start',
    marginLeft: 8
  }
});

export default styles;
